<template>
    <div class="py-3 row" v-if="eligibility?.episode.success == 'Yes'">
        <h6 class="col-12"><i class="fas fa-calendar-alt text-app-primary"></i> Home Health Episodes</h6>
        <div class="col-12 mt-2">
            <table class="table table-responsive-md border mb-0">
                <thead>
                    <tr class="bg-table-header">
                        <th class="text-start">Episode</th>
                        <th class="text-start">Payer</th>
                        <th class="text-start">Name</th>
                        <th class="text-center">Date</th>
                        <th class="text-start">Reference ID Qualifier</th>
                        <th class="text-start">Reference ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="episode of eligibility.episode.episodes">
                        <td class="text-start">
                            <span v-if="episode.period_date_range">
                                <span>{{ formatDate(episode.period_date_range.split("-")[0]) }}</span>
                                -
                                <span>{{ formatDate(episode.period_date_range.split("-")[1]) }}</span>
                            </span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="episode.payer">{{ episode.payer }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="episode.name">{{ episode.name }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-center">
                            <span v-if="episode.date">{{ formatDate(episode.date) }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="episode.reference_id_qualifier">{{ episode.reference_id_qualifier }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="episode.reference_id">{{ episode.reference_id }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { formatDate } from "../../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    props: {
        eligibility: {
            type: Object
        }
    },
    data() {
        return {
            formatDate
        };
    }
});
</script>
